export default __webpack_public_path__ + "static/media/profile.f35fcca3.png";